import { msg } from '@lingui/core/macro';
import type { MessageDescriptor } from 'shared/i18n';

export enum Roles {
  admin = 'ROLE_TOURNAMENT_ADMIN',
  super_admin = 'ROLE_ADMIN',
  user = 'ROLE_USER',
}

// Подпись — дескриптор: переводится на месте показа, `t(option.label)`.
export const ROLES_OPTIONS: { value: Roles; label: MessageDescriptor }[] = [
  {
    value: Roles.admin,
    label: msg`Админ`,
  },
];
